/**
 * This is a dynamic import version of index.js.
 * When frontend.exclude.editor.plugins.fragment is turned on
 * Backend won't load editor-plugins.html (in editor.action).
 * (from wr!com.atlassian.confluence.plugins.editor-loader:background-loading-editor)
 * Frontend is responsible for loading the import dynamically.
 */
export function initializeEditorPlugins() {
	return import(/* webpackChunkName: "loadable-initialize" */ './initialize').then(
		({ triggerEditorPluginsLoaded }) => triggerEditorPluginsLoaded(),
	);
}
